import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 12h2l2 -5l3 10l3 -10l3 10l3 -10l1.5 5h2.5","key":"svg-0"}]]

const IconCircuitResistor = createReactComponent('outline', 'circuit-resistor', 'CircuitResistor', __iconNode);

export default IconCircuitResistor;